import React, { useEffect, useState } from 'react'
import { Button, CheckBox, TextField, Typography } from '@dasa-health/components-react'
import { Flex, Spacing } from '@dasa-health/alma-react'
import { CustomForm } from 'redesign/components/organisms/CPFPhasedLoginForm/styles'
import { WarningServiceIsDown } from 'redesign/components/organisms'
import { CustomSpacing } from 'redesign/components/organisms/CPFPhasedLogin/styles'
import { TemplateContainer } from 'redesign/components/templates'
import { useLinkLoginForm } from 'redesign/hooks/useLinkLoginForm'
import { getQueryParamsValue } from 'utils'
import { useLocation, useHistory } from 'react-router-dom'
import { FormCheckboxWrapper } from './styles'
import { useRemoteConfig } from 'modules/RemoteConfig/hooks/useRemoteConfig'
import { ROUTES_PATH } from 'constants/routesPath'
import { TermsCheck } from './components/TermsCheck'
import { useLoginService } from 'services/useLoginService'
import { FullPageLoading } from 'components'
import { ErrorPage } from './components/ErrorPage'
import { useSignUpAnaytics } from 'hooks/useSignUpAnaytics'

export function LoginWithLink() {
    const location = useLocation()
    const history = useHistory()
    const { isFeatureEnabled } = useRemoteConfig()
    const { values, errors, touched, isSubmitting, isServiceDown, setFieldValue, handleSubmit, handleChangeCpf } = useLinkLoginForm()
    const { getMagicLinkById } = useLoginService()
    const [termsChecked, setTermsCheked] = useState(false)
    const [loading, setLoading] = useState(true)
    const [name, setName] = useState<string | undefined>(undefined)
    const [isError, setIsError] = useState<boolean>(false)
    const { dispatchAnalyticsMagicLinkFeedback } = useSignUpAnaytics()

    const IS_MAGIC_LINK_ENABLED = isFeatureEnabled('AUTH_ENABLE_MAGIC_LINK')

    const id: string | undefined = getQueryParamsValue(location, 'uuid') || undefined
    const firstName = name ? name.trim().split(/\s+/)[0] : ''
    const saudacao = `${name ? ` ${firstName}` : 'Olá'}`

    const cpfValidation = touched.cpf && errors.cpf
    const disableCTAButton = !values.cpf || !!errors.cpf || isSubmitting || !termsChecked

    const goToLoginPage = () => {
        history.replace(ROUTES_PATH.SIGN_IN)
    }

    const handleCpfChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { target } = e
        handleChangeCpf(e)
        sessionStorage.setItem('cpf', target.value)
    }

    if (!IS_MAGIC_LINK_ENABLED && !id) {
        goToLoginPage()
    }

    async function getMagicLinkData() {
        try {
            const response = await getMagicLinkById(id!)
            setName(response?.patientName)
            setFieldValue('id', id)

            if (response?.isExpired) {
                dispatchAnalyticsMagicLinkFeedback('confirmCpf', { errorMessage: 'Link Expirado' })
                history.replace(ROUTES_PATH.SIGN_IN)
            }

            if (response?.isUsed) {
                dispatchAnalyticsMagicLinkFeedback('confirmCpf', { errorMessage: 'Link Já Utilizado' })
                history.replace(ROUTES_PATH.SIGN_IN)
            }

            if (response?.isAttemptLimitExceeded) {
                dispatchAnalyticsMagicLinkFeedback('confirmCpf', { errorMessage: 'Tentativas Excedidas' })
                setIsError(true)
            }
        } catch (error) {
            goToLoginPage()
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        getMagicLinkData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id])

    if (loading) {
        return <FullPageLoading data-testid="full-page-loading" />
    }

    return (
        <>
            {isError ? (
                <ErrorPage ctaText="Acessar Nav Dasa" handleClick={goToLoginPage} />
            ) : (
                <TemplateContainer renderHeader>
                    <CustomSpacing />
                    <Typography as="h1" size={4} sx={{ color: 'rgba(22, 22, 22, 1)', fontWeight: '700', lineHeight: '1.8rem' }}>
                        {saudacao}, você acaba de chegar no Nav Dasa, seu assistente de saúde.
                    </Typography>
                    {isServiceDown && <WarningServiceIsDown />}

                    <CustomForm onSubmit={handleSubmit}>
                        <Flex flexDirection="column" height="100%">
                            {isServiceDown && <WarningServiceIsDown />}
                            <Spacing height={isServiceDown ? 24 : 24} />

                            <TextField
                                autoComplete="username"
                                className="textInput"
                                data-current-service="Entrar"
                                data-item-position="Campo"
                                data-item-text="Digite o CPF"
                                helperText={touched.cpf ? errors.cpf : ''}
                                inputMode="numeric"
                                label="Digite o CPF para continuar"
                                name="cpf"
                                onChange={handleCpfChange}
                                readOnly={isSubmitting}
                                type="tel"
                                value={values.cpf}
                                variant={cpfValidation ? 'error' : 'default'}
                            />

                            <Spacing height={cpfValidation ? 64 : 32} />

                            <Flex flexDirection="column" marginTop={'initial'}>
                                <FormCheckboxWrapper>
                                    <CheckBox
                                        checked={termsChecked}
                                        className="form__checkbox"
                                        data-current-service="Entrar"
                                        data-item-position="Radio Button"
                                        data-item-text="Li e aceito os Termos de Uso"
                                        label={((<TermsCheck />) as unknown) as string}
                                        name="terms"
                                        onChange={() => setTermsCheked(!termsChecked)}
                                        sx={{ alignItems: 'flex-start' }}
                                    />
                                </FormCheckboxWrapper>
                            </Flex>

                            <Spacing height={32} />

                            <Flex flexDirection="column" marginTop={'initial'}>
                                <Button disabled={disableCTAButton} isLoading={isSubmitting} width="100%">
                                    Acessar Nav Dasa
                                </Button>
                            </Flex>
                        </Flex>
                    </CustomForm>
                </TemplateContainer>
            )}
        </>
    )
}
